module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }